import { call, put, takeLatest } from 'redux-saga/effects'
import {
  pipe,
  prop,
  map,
  gt,
} from 'ramda'
import { authenticatedCall, validateSurveys } from 'shared/helpers/sagas'
import * as types from 'store/sidebar/sidebarTypes'
import API from 'store/sidebar/sidebarApis'

export function* watchLaunchSurveys ({ payload }) {
  yield* authenticatedCall('LAUNCH_SURVEYS', function* () {
    yield call(validateSurveys, map(prop('id'), payload))
    yield call(API.launchSurveys, payload)
    yield put({ type: 'LAUNCH_SURVEYS_SUCCEEDED', payload})
    yield put({ type: 'SHOW_MESSAGE', payload: {message: `Your survey${gt(payload.length, 1) ? 's have' : ' has'} been launched`}})
  })
}

export function* watchCloseSurveys ({ payload }) {
  yield* authenticatedCall('CLOSE_SURVEYS', function* () {
    yield call(API.closeSurveys, payload)
    yield put({ type: 'CLOSE_SURVEYS_SUCCEEDED', payload })
    yield put({ type: 'SHOW_MESSAGE', payload: {message: `Your survey${gt(payload.length, 1) ? 's have' : ' has'} been closed`}})
  })
}

export default function* watchSidebarSaga () {
  yield takeLatest(types.LAUNCH_SURVEYS_REQUESTED, watchLaunchSurveys)
  yield takeLatest(types.CLOSE_SURVEYS_REQUESTED, watchCloseSurveys)
}
